define([
        'underscore',
        'edge/quoteandbind/common/models/Submission',
        'edge/quoteandbind/pa/models/Driver',
        'edge/quoteandbind/common/models/Person',
        'edge/quoteandbind/pa/models/Vehicle'
    ], (_, Submission, Driver, Person, Vehicle)=> {
        let nextId;

        const PASubmissionDraftDataExtension = function (submission) {
            nextId = submission.nextId;

            const data = submission.draftData.lobs.personalAuto;

            if (data && _.isObject(data)) {
                this.drivers = _.map(data.drivers, (d)=> {
                    const driver = new Driver(d);
                    driver.person = submission.findPerson(submission, d.person);
                    return driver;
                }, this);

                this.vehicles = _.map(data.vehicles, (v)=> {
                    return new Vehicle(v);
                }, this);

                this.preQualQuestionSets = data.preQualQuestionSets;
            } else {
                this.drivers = [];
                this.vehicles = [];
                this.preQualQuestionSets = [];
            }
        };

        PASubmissionDraftDataExtension.prototype.createDriver = function (person) {
            const driver = new Driver({
                person,
                dateOfBirth: person.dateOfBirth
            });
            // extend
            if (person && person.primaryAddress) {
                driver.licenseState = person.primaryAddress.state;
            }
            driver.tempID = nextId();

            this.drivers.push(driver);
            return driver;
        };

        PASubmissionDraftDataExtension.prototype.removeDriver = function (driver) {
            const idx = _.indexOf(this.drivers, driver);
            if (idx >= 0) {
                this.drivers.splice(idx, 1);
            }
        };

        PASubmissionDraftDataExtension.prototype.createVehicle = function (person) {
            const v = new Vehicle({tempID: nextId()});
            if (person && person.primaryAddress) {
                v.licenseState = person.primaryAddress.state;
            }
            this.vehicles.push(v);
            return v;
        };

        PASubmissionDraftDataExtension.prototype.removeVehicle = function (vehicle) {
            const idx = _.indexOf(this.vehicles, vehicle);
            if (idx >= 0) {
                this.vehicles.splice(idx, 1);
            }
        };

        PASubmissionDraftDataExtension.prototype.getDriverForPerson = function (person) {
            const driver = _.findWhere(
                this.drivers, {person}
            );

            if (driver.dateOfBirth !== person.dateOfBirth) {
                driver.dateOfBirth = person.dateOfBirth;
            }

            return driver;
        };

        return PASubmissionDraftDataExtension;
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/pa/models/PASubmissionDraftDataExtension.js